import { createSlice } from "@reduxjs/toolkit";
import { playerOptions as initialPlayerOptions } from "../../../../config/options";
import _ from "lodash";

const playerSlice = createSlice({
  name: "player",
  initialState: initialPlayerOptions,
  reducers: {
    // call as updatePlayerState({data: {imageMagickObj: {resultimage: "cheese"}}})
    updatePlayerState(state, action) {
      let { data } = action.payload;
      state = _.merge(state, data);
    },
    updateNode(state, action) {
      let { obj, node } = action.payload;
      if (!node) {
        node = state.currentNode;
      }
      state.finalObj.nodes[node] = _.merge(state.finalObj.nodes[node], obj);
    },
    resetNodes(state, action) {
      let { data } = action.payload;
      state.finalObj.nodes = data;
    },
    // use currentNode to track which frame is selected in multiple canvas products
    setCurrentNode(state, action) {
      state.currentNode = action.payload;
    },
    // updateDimensions({canWidth: 10})
    updateDimensions(state, action) {
      Object.keys(action.payload).forEach((key) => {
        state.dimensions[key] = action.payload[key];
      });
    },
  },
});

export const {
  updatePlayerState,
  updateNode,
  resetNodes,
  updateDimensions,
  setCurrentNode,
} = playerSlice.actions;
export default playerSlice.reducer;
